import { render, staticRenderFns } from "./basicTab.vue?vue&type=template&id=07b13b1d&scoped=true&"
import script from "./basicTab.vue?vue&type=script&lang=js&"
export * from "./basicTab.vue?vue&type=script&lang=js&"
import style0 from "./basicTab.vue?vue&type=style&index=0&id=07b13b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b13b1d",
  null
  
)

export default component.exports